import React, { forwardRef, useEffect } from 'react'
import Stack from '@mui/material/Stack'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert, { AlertProps } from '@mui/material/Alert'
import { IInitialContextValue } from '../../reducers/actionType/actionType'
import { useCustomContext } from '../../Context'
import { TSnackbarProps } from '../../types'

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />
})

export function CustomizedSnackbars({ vertical, horizontal }: TSnackbarProps) {
  const { initialState, dispatchAlertClose }: IInitialContextValue = useCustomContext()
  const { alertOpen, snackbar } = initialState

  const handleClose = () => {
    dispatchAlertClose()
  }

  useEffect(() => {
    // Effect intentionally empty, dependency array monitors snackbar changes
  }, [snackbar.status, alertOpen])

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {initialState.snackbar.message ? (
        <Snackbar
          anchorOrigin={{
            vertical: vertical ? vertical : 'top',
            horizontal: horizontal ? horizontal : 'right',
          }}
          key={'top' + 'right'}
          open={alertOpen}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={snackbar.type === 'success' ? 'success' : 'error'}
            sx={{ width: '100%' }}
            role='status'
            aria-live='polite'
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      ) : null}
    </Stack>
  )
}
